import { AuthContext } from "../Authorisation/AuthContext";
import { useContext, useState } from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import LogoutIcon from "@mui/icons-material/Logout";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import VerifiedIcon from '@mui/icons-material/Verified';
import EmailIcon from '@mui/icons-material/Email';
import SaveIcon from '@mui/icons-material/Save';
import SettingsIcon from '@mui/icons-material/Settings';
import { useLocation, useNavigate } from "react-router-dom";
import { SessionContext } from "../Contexts/SessionContext";
import Dialog from "@mui/material/Dialog";
import { APIContext } from "../Contexts/APIContext";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { TelemetryContext } from "../Contexts/TelemetryContext";
import Tooltip from "@mui/material/Tooltip";
import { ContactFormContext } from "../Contexts/ContactFormContext";
import { UserPromptContext } from "../Contexts/UserPromptContext";

export default function NavBar() {
    const { openContactForm } = useContext(ContactFormContext);
    const { openMailchimpPrompt } = useContext(UserPromptContext);
    const { saveSession } = useContext(SessionContext);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [saveName, setSaveName] = useState(`New_Session_${new Date().toISOString()}`);
    const [openSaveDialog, setOpenSaveDialog] = useState(false);
    const open = Boolean(anchorEl);
    const { logout, userDetails } = useContext(AuthContext);
    const { getPDF } = useContext(APIContext);
    const { logFileAccess } = useContext(TelemetryContext);
    const location = useLocation();
    const navigate = useNavigate();

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        handleClose();
        logout();
    };

    const settingNavigation = () => {
        navigate("/settings");
    };

    const handleOpenDialog = () => {
        openContactForm();
    };

    const handleOpenPDF = () => {
        const currentYear = new Date().getFullYear();
        logFileAccess(`TRICS Good Practice Guide ${currentYear}`, "NavBar");
        getPDF(
            'Document',
            `GetLibraryFile?folder=GoodPracticeGuide&fileName=TRICS Good Practice Guide ${currentYear}`,
            `TRICS Good Practice Guide ${currentYear}`,
            true
        );
    };

    const sessionConfirmSave = () => {
        saveSession(saveName, "manual");
        setOpenSaveDialog(false);
        setSaveName(`New_Session_${new Date().toISOString()}`);
    }
    const editName = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSaveName(event.target.value);
    }

    return (
        <>
            <Stack direction="row" alignItems="center" spacing={2}>
                    <Tooltip title="Save Session" placement="bottom">
                        <IconButton sx={{ color: "white" }} disabled={location.pathname.includes('admin')} onClick={() => setOpenSaveDialog(true)}>
                            <SaveIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Contact TRICS" placement="bottom">
                        <IconButton sx={{ color: "white" }} onClick={handleOpenDialog}>
                            <EmailIcon />
                        </IconButton>
                    </Tooltip>
                    {!userDetails?.mailchimpOptedIn && userDetails?.role !== 'Admin' && userDetails?.role !== 'SuperAdmin' &&
                        <Tooltip title="Mailchimp" placement="bottom">
                            <Button sx={{ color: "white" }} onClick={openMailchimpPrompt}>
                                Receive important trics updates
                            </Button>
                        </Tooltip>
                    }
                    <Tooltip title="Good Practice Guide" placement="bottom">
                        <IconButton sx={{ color: "white" }} onClick={handleOpenPDF}>
                            <VerifiedIcon />
                        </IconButton>
                    </Tooltip>
                <Typography variant="body2">{userDetails?.userEmail}</Typography>
                <IconButton
                    onClick={handleClick}
                    size="small"
                    aria-controls={open ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    sx={{ color: "white" }}
                >
                    <AccountCircleIcon fontSize="large" />
                </IconButton>
                <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={open}
                    onClose={handleClose}
                    onClick={handleClose}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                    <MenuItem onClick={handleLogout}>
                        <ListItemIcon>
                            <LogoutIcon fontSize="small" />
                        </ListItemIcon>
                        Logout
                    </MenuItem>
                    <MenuItem onClick={settingNavigation}>
                        <ListItemIcon>
                            <SettingsIcon fontSize="small" />
                        </ListItemIcon>
                        Settings
                    </MenuItem>
                </Menu>
            </Stack>
            <Dialog open={openSaveDialog} onClose={() => setOpenSaveDialog(false)} maxWidth="md" fullWidth>
                <DialogTitle>Save Session</DialogTitle>
                <DialogContent>
                    <Typography>Enter a name for the session</Typography>
                    <TextField value={saveName} onChange={editName} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenSaveDialog(false)}>Cancel</Button>
                    <Button onClick={sessionConfirmSave}>Save</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
